const logger = require('../utils/logger');
const fetcher = require('../utils/fetcher');
const stateSubscriber = require('./stateSubscriber');
const frontendTrackingAgent = require('../track_events/track.frontendevents.utils');
const cmpClient = require('@edreamsodigeo/frontend-cmp-client');

Odigeo.SessionScope.logger = logger;
Odigeo.SessionScope.fetcher = fetcher;
Odigeo.SessionScope.stateSubscriber = stateSubscriber;

Odigeo.on('jsLogger:disable', logger.disableLoggers);

Odigeo.on('analytics:tracking', function(event) {
    Odigeo.requireWidget('google-analytics', 'googleanalytics', function(widget) {
        widget.execute(event.type, event.data);
    });
});

Odigeo.on('analytics:trackClick', function(event) {
    frontendTrackingAgent.trackClick(event).catch((error) => {
        console.warn(error);
    });
});

Odigeo.on('analytics:trackComponent', function(event) {
    frontendTrackingAgent.trackComponentDisplayed(event).catch((error) => {
        console.warn(error);
    });
});

Odigeo.on('cmp:isAllowed', function(event) {
    const isKeyAllowed = cmpClient.isAllowed(event.type, event.key);
    if (typeof event.cb === 'function') event.cb(isKeyAllowed);
});

Odigeo.on('cmp:onChangeUserCMP', function(event) {
    if (typeof event.cb === 'function') cmpClient.onChangeUserCMP(event.cb);
});


// Tells Astro islands that the handlers above are registered, so events sent
// through Odigeo.trigger from now on reach the legacy tracking widget and CMP client.
// Islands check the flag first and listen for the event only if it is not set yet.
window.__OF1_BUS_READY__ = true;
window.dispatchEvent(new window.Event('of1:bus-ready'));
